export const LABEL_PHONE_TITLE = "Вход и регистрация";
export const LABEL_CODE_TITLE = "Введите код из СМС";
export const LABEL_PHONE_SUBTITLE = "Нужен только номер телефона";
export const LABEL_CODE_SUBTITLE = "Отправлен на номер";
export const LABEL_INCORRECT_PHONE = "Номер телефона введён некорректно";
export const LABEL_BUTTON_NEXT = "Далее";
export const LABEL_OTP_INCORRECT = "Неверный код. Попробуйте ещё раз";
export const LABEL_RESEND_CODE = "Отправить код повторно";
export const LABEL_EXPIRES_IN = "Повторить запрос через";
